import { createStyles } from '@material-ui/core';
import { LumaTheme } from 'embeds/core/styles/getTheme';

export default ({ spacing: { unit } }: LumaTheme) =>
  createStyles({
    radioGroup: {
      padding: `${unit * 2}px ${unit * 2}px 0 ${unit * 2}px`,
    },
    radio: {
      fontSize: 17,
    },
    customDateRange: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: 46,
      padding: `0px ${unit * 2}px`,
    },
    rangeTextWrapper: {
      margin: `0 ${unit * 2}px`,
    },
    textFieldWrapper: {
      width: 220,
    },
    textFieldInput: {
      fontSize: 14,
      height: '36px !important',
    },
    textFieldHelperError: {
      position: 'absolute',
      top: 36,
    },
    padding: {
      padding: `${unit}px ${1.5 * unit}px`,
      paddingTop: 0,
    },
  });
